import {
  TEMPLATE_ID_BASE_SHARED_STRUCTURE,
  TEMPLATE_ID_DUAL_SHARE_CLASS,
  TEMPLATE_ID_LONG_TERM_VALUE_FUND,
  TEMPLATE_ID_OMIT_ETHIK_KONTROVERSE,
} from './templateConstants';

/** Display label overrides for STAMMDATEN fields (field key → label without colon) */
const KVG_STAMMDATEN_LABELS: Record<string, string> = {
  verwaltungsgesellschaft: 'KVG',
};

const KVG_LABEL_TEMPLATE_IDS = new Set<string>([
  TEMPLATE_ID_BASE_SHARED_STRUCTURE,
  TEMPLATE_ID_LONG_TERM_VALUE_FUND,
  TEMPLATE_ID_OMIT_ETHIK_KONTROVERSE,
  TEMPLATE_ID_DUAL_SHARE_CLASS,
]);

/** Config form label (no trailing colon) */
export function getStammdatenFormLabel(templateId: string | undefined, fieldKey: string, defaultLabel: string): string {
  if (templateId && KVG_LABEL_TEMPLATE_IDS.has(templateId)) {
    return KVG_STAMMDATEN_LABELS[fieldKey] ?? defaultLabel;
  }
  return defaultLabel;
}

/** Preview/PDF row label (typically ends with ":") */
export function getStammdatenRowLabel(
  templateId: string | undefined,
  fieldKey: string,
  defaultLabel: string,
): string {
  if (!templateId || !KVG_LABEL_TEMPLATE_IDS.has(templateId)) return defaultLabel;
  const override = KVG_STAMMDATEN_LABELS[fieldKey];
  if (!override) return defaultLabel;
  return defaultLabel.endsWith(':') ? `${override}:` : override;
}
